import { listSearchSchema } from '@/shared/patterns/list-search';

import { dimensaSubmissionFilters } from './dimensa-submission.filters';

/** `validateSearch` de `/ccb/cessoes/submissoes-dimensa` (U07): página, tamanho, ordem e os filtros legíveis. Leve, para a rota. */
export const dimensaSubmissionSearch = listSearchSchema({ ...dimensaSubmissionFilters.shape });
